import React from 'react';
import clsx from 'clsx';

export const DownloadLogsPageTitle = ({
  title,
  subTitle,
  endComponent,
  className,
  wrapperClassName,
  titleComponent,
}) => {
  return (
    <div
      className={clsx('flex max-lg:flex-col lg:gap-6 gap-4', wrapperClassName)}
    >
      <div className={clsx('flex flex-col gap-x-3 gap-y-4', className)}>
        {titleComponent && titleComponent}
        {title && title}
        {subTitle && <div className="text-body">{subTitle}</div>}
      </div>
      {endComponent}
    </div>
  );
};

export default DownloadLogsPageTitle;
